module.exports = __webpack_public_path__ + "static/media/Dormer Bond Inc. - Summary of Allegations.b6167b17.pdf";